import { DEFAULT_FEATURES } from '@/config/features/featureFlags'
import { MarketEnum } from '@/config/tenants/types'

import type { TenantConfig, TenantRegistry } from '@/config/tenants/types'

// Mediq Denmark
const mediqDK: TenantConfig = {
  id: 'mediq_dk',
  marketId: MarketEnum.mediq_dk,
  // TODO: This should be dynamic based on the tenant, but for now we can hardcode it since we only have one tenant
  sapCatalogId: 'mediqdkProductCatalog',
  marketSanity: ['dk-b2c', 'dk-b2b'],
  name: 'Mediq Denmark',
  domains: ['dev2-shop.mediqdanmark.dk', 'test-shop.mediqdanmark.dk', 'mediqdanmark.dk'],
  //TODO: Include proper language support using en-GB etc. for dialects
  languages: ['dk', 'en'],
  locale: 'da-DK',
  defaultLanguage: 'dk',
  currency: 'DKK',
  timezone: 'Europe/Copenhagen',
  countryCode: 'DK',
  dateFormat: 'YYYY-MM-DD',
  countryName: 'Denmark',
  postalCodeLength: 4,
  features: {
    ...DEFAULT_FEATURES,
    organisation: true,
  },
}

// Mediq Sweden
const mediqSE: TenantConfig = {
  id: 'mediq_se',
  marketId: MarketEnum.mediq_se,
  sapCatalogId: 'mediqseb2bProductCatalog',
  marketSanity: ['se-b2b'],
  name: 'Mediq Sweden',
  domains: ['b2bmediqse.dev.mediq.com', 'b2bmediqse.tst.mediq.com', 'pilot-shop.mediq.se', 'mediq.se'],
  languages: ['sv', 'en'],
  locale: 'sv-SE',
  defaultLanguage: 'sv',
  currency: 'SEK',
  timezone: 'Europe/Stockholm',
  countryCode: 'SE',
  dateFormat: 'YYYY-MM-DD',
  countryName: 'Sweden',
  postalCodeLength: 5,
  features: {
    ...DEFAULT_FEATURES,
    b2c: false,
    organisation: true,
  },
}

// Mediq Norway
const mediqNO: TenantConfig = {
  id: 'mediq_no',
  marketId: MarketEnum.mediq_no,
  sapCatalogId: 'mediqnob2bProductCatalog',
  marketSanity: ['no-b2b'],
  name: 'Mediq Norway',
  domains: [
    'b2bmediqnorgeno.dev.mediq.com',
    'b2bmediqnorgeno.tst.mediq.com',
    'pilot-shop.mediqnorge.no',
    'mediqnorge.no',
  ],
  languages: ['no', 'en'],
  locale: 'no-NO',
  defaultLanguage: 'no',
  currency: 'NOK',
  timezone: 'Europe/Oslo',
  countryCode: 'NO',
  dateFormat: 'DD.MM.YYYY',
  countryName: 'Norway',
  postalCodeLength: 4,
  features: {
    ...DEFAULT_FEATURES,
    b2c: false,
    organisation: true,
  },
}

// Mediq Finland
const mediqFI: TenantConfig = {
  id: 'mediq_fi',
  marketId: MarketEnum.mediq_fi,
  sapCatalogId: 'mediqfib2bProductCatalog',
  marketSanity: ['fi-b2b'],
  name: 'Mediq Finland',
  domains: ['b2bmediqfi.dev.mediq.com', 'b2bmediqfi.tst.mediq.com', 'pilot-shop.mediq.fi', 'mediq.fi'],
  languages: ['fi', 'en', 'sv'],
  locale: 'fi-FI',
  defaultLanguage: 'fi',
  currency: 'EUR',
  timezone: 'Europe/Helsinki',
  countryCode: 'FI',
  dateFormat: 'D.M.YYYY',
  countryName: 'Finland',
  postalCodeLength: 5,
  features: {
    ...DEFAULT_FEATURES,
    b2c: false,
    sailabCode: true,
    organisation: true,
  },
}

export const TENANTS: TenantRegistry = {
  mediq_dk: mediqDK,
  mediq_se: mediqSE,
  mediq_no: mediqNO,
  mediq_fi: mediqFI,
}

export const ALL_TENANTS = Object.values(TENANTS)
